package ahlers.presence.web.client

import com.raquo.laminar.api.L._

/**
 * @since December 22, 2020
 * @author <a href="mailto:michael@ahlers.consulting">Michael Ahlers</a>
 */
object ContactPage {

  def apply(): Div =
    div(
      h1("Contact"),
      p("Nullam pellentesque mauris quis mauris vulputate viverra. Aliquam maximus enim fringilla nisl euismod suscipit. Nulla faucibus auctor velit. Nam massa orci, ornare ac lorem in, congue tempus dui. Phasellus mollis metus non nisl imperdiet porttitor id in leo. Curabitur in viverra mauris. Nam suscipit nisl eu egestas ultricies. Pellentesque purus massa, mattis sed facilisis sit amet, eleifend quis lacus. Pellentesque in dapibus turpis. Duis est augue, condimentum id vehicula at, molestie id arcu. Donec fringilla tortor sed ante iaculis gravida.")
    )

}
